import React from "react";

const FAQ_ITEMS = [
  { q: "What deployment options are available?", a: "Choose Cloud, On-Premise (Windows), or Hybrid — switch or scale anytime." },
  { q: "Does Armada POS work offline?", a: "Yes. Continue billing offline; all data syncs back when online." },
  { q: "Is there a free trial?", a: "Yes — start a full-feature trial without a credit card." },
  { q: "Which industries are supported?", a: "Restaurants, cafés, retail, supermarkets, pharmacies, salons, gyms, hotels, clinics, and multi-outlet chains." },
  { q: "Can I manage multiple outlets or franchises?", a: "Yes. Centralized pricing, inventory transfers, approvals, and consolidated reports." },
  { q: "Is local tax/e-invoicing supported?", a: "Yes. VAT/GST, multi-currency, and localization for many countries; we keep up with changes." },
  { q: "How fast is setup?", a: "Most businesses start the same day with guided onboarding and training." },
  { q: "Can you migrate my existing data?", a: "Yes. Import items, customers, suppliers, recipes, and historical balances." },
  { q: "Do you support loyalty & CRM?", a: "Yes. Points, vouchers, targeted promotions, purchase history." },
  { q: "What about hardware compatibility?", a: "Works with common printers, scanners, cash drawers, scales, KOT/KDS screens, and Windows laptops/desktops." },
  { q: "Is my data secure?", a: "Encrypted storage, role-based access, audit history, and secure backups." },
  { q: "What support is included?", a: "24×7 support via phone, email, live chat, WhatsApp, and remote assistance. On-site in select regions." },
  { q: "Can I integrate delivery and e-commerce?", a: "Yes — Armada Online Ordering and third-party platforms." },
  { q: "Do you offer owner dashboards/mobile?", a: "Yes — real-time KPIs, sales, top items, exceptions, and alerts." },
  { q: "Pricing models?", a: "Perpetual license with AMC or annual subscription — choose what fits your cash flow." },
  { q: "Can I customize Armada POS?", a: "Yes. Industry-essential tweaks are free; custom features are feasible and quoted if out-of-scope." },
  { q: "Is training provided?", a: "Yes. Role-based training for cashiers, managers, and owners." },
  { q: "Does Armada handle recipes & KOT?", a: "Yes — recipes/BOM, KOT, KDS, and kitchen routing for F&B." },
  { q: "Does Armada support returns/exchanges?", a: "Yes — with reasons, validations, and permissions." },
  { q: "Can I run promotions and bundles?", a: "Yes — BOGO, mix-and-match, timed prices, combos, and coupons." },
  { q: "Which countries are supported?", a: "We support global rollouts with localization across the GCC, UK, USA, Canada, Australia/New Zealand, India/South Asia, SE Asia, and more." },
  { q: "How do I start a trial?", a: "Fill the form below — we’ll set up your account and guide onboarding." },
  { q: "Can I access from mobile?", a: "Yes — owner dashboards and web access on the go." },
  { q: "What about performance on older hardware?", a: "Optimized client apps; runs well on typical Windows POS terminals and laptops." },
  { q: "What reporting is available?", a: "Live sales, stock, P&L, wastage, staff, outlet performance, and exports." },
  { q: "Do you offer discounts?", a: "Yes — 25% for startups; 50% for nonprofits, education, and religious orgs." },
];


const FAQ = () => (
  <section id="faq" className="py-16">
    <div className="max-w-7xl mx-auto px-4">
      <h2 className="text-2xl md:text-3xl font-extrabold">Frequently Asked Questions</h2>
      <p className="mt-2 text-slate-600">Straight answers to common questions about Armada POS.</p>

      <div className="mt-8 divide-y rounded-2xl border">
        {FAQ_ITEMS.map((item, idx) => (
          <details key={idx} className="group open:bg-slate-50">
            <summary className="flex items-center justify-between cursor-pointer px-5 py-4">
              <span className="font-semibold">{item.q}</span>
              <span className="text-slate-500 group-open:hidden">+</span>
              <span className="text-slate-500 hidden group-open:inline">−</span>
            </summary>
            <div className="px-5 pb-5 text-slate-700">{item.a}</div>
          </details>
        ))}
      </div>

      <div className="mt-8">
        <a
          href="#signup"
          className="inline-flex items-center rounded-lg px-5 py-3 bg-blue-600 text-white font-semibold hover:bg-blue-700"
        >
          Still have questions? Start a Free Trial
        </a>
      </div>
    </div>
  </section>
);

export default FAQ;
